import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./styles/global.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import { App } from "./App";
import theme from "./utils/theme/theme";
import { store } from "./services/state/store";
import reportWebVitals from "./reportWebVitals";
import { UserService } from "./services/UserService";
import { configure } from "./services/HttpsService";

const root = createRoot(document.getElementById("root") as HTMLElement);
const renderApp = () =>
  root.render(
    <StrictMode>
      <ChakraProvider theme={theme}>
        <Provider store={store}>
          <App />
        </Provider>
      </ChakraProvider>
    </StrictMode>
  );

UserService.initKeycloak(renderApp);
configure(process.env.REACT_APP_BACKEND_API, (config) => {
  config.headers["Authorization"] = `Bearer ${UserService.getToken()}`;
  return config;
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
